import PromoPlacementManager from '@/js/desktop/services/PromoPlacementManager';

const A51_PLACEMENT_TYPE = 'a51';
const MOBWEB_PLACEMENT_MARKER = 'mobweb';

function getAdminPanelPlacements() {
    const placements = window.appConfig?.promoPlacements ?? [];

    if (!window.appConfig?.isMobileDomain) {
        return placements.filter((placement) => !placement.placementId?.includes(MOBWEB_PLACEMENT_MARKER));
    }

    const mobwebPlacements = placements.filter((placement) => placement.placementId?.includes(MOBWEB_PLACEMENT_MARKER));

    return mobwebPlacements.length > 0 ? mobwebPlacements : placements;
}

function getSearchCountryId() {
    const managerCountryId = PromoPlacementManager.getInstance().currentCountryId;

    if (managerCountryId) {
        return Number(managerCountryId);
    }

    const { hash, search } = window.location;
    const query = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : search.replace('?', '');
    const toCountry = new URLSearchParams(query).get('toCountry');

    return toCountry ? Number(toCountry) : null;
}

export const hasA51PlacementForCurrentCountry = () => {
    const countryId = getSearchCountryId();

    if (!countryId) {
        return false;
    }

    const { getPlacementType } = PromoPlacementManager.getInstance();

    return getAdminPanelPlacements().some(
        (placement) => Number(placement.countryId) === countryId
            && getPlacementType(placement.placementId) === A51_PLACEMENT_TYPE,
    );
};
